module.exports = __webpack_public_path__ + "PR4-73565480.webp";